import { render, staticRenderFns } from "./prettyNumber.vue?vue&type=template&id=1e9ea45e"
import script from "./prettyNumber.vue?vue&type=script&lang=js"
export * from "./prettyNumber.vue?vue&type=script&lang=js"
import style0 from "./prettyNumber.vue?vue&type=style&index=0&id=1e9ea45e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports